import Button from 'ui/Button';
import Dialog from 'ui/Dialog';
import Icon from 'ui/Icon';
import { VStack } from 'ui/Layout';
import Link from 'ui/Link';
import { Text } from 'ui/Typography';

import { websiteLinkTo } from '../../../utils/routes';
import DownloadPNGBanner from '../../banners/DownloadPNGBanner';

type Props = {
  open: boolean;
  onClose: () => void;
  message: string;
  buttonText: string;
  showDownloadBanner?: boolean;
};

// TODO: Rename to ManageSubscriptionDialog and integrate with opener trigger
const ManageSubscriptionModal: React.FC<Props> = ({
  open,
  onClose,
  message,
  buttonText,
  showDownloadBanner,
}) => (
  <Dialog.Root open={open} onOpenChange={onClose}>
    <Dialog.Content>
      <Dialog.Header>
        SankeyArt subscription <Icon icon="crown" ml={2} />
      </Dialog.Header>
      <Dialog.Body>
        <VStack alignItems="stretch" gap={4}>
          <Text>{message}</Text>
          {showDownloadBanner && <DownloadPNGBanner />}
        </VStack>
      </Dialog.Body>
      <Dialog.Footer>
        <Link href={websiteLinkTo('/subscriptions/')} isExternal>
          <Button variant="primary-solid">{buttonText}</Button>
        </Link>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
);

export default ManageSubscriptionModal;
